module.exports = __webpack_public_path__ + "PS.png?575d2cd298e8c0f88fed27c5b4527309";